common.View.create('shop::canvas.blocks.shop.categories.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel')
            .owlCarousel({
                loop: false,
                margin: 32,
                nav: true, // this.element.find('.owl-carousel').data('show-navigation')
                navText : [
                    "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-6 w-6\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\">\n" +
                    "  <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M15 19l-7-7 7-7\" />\n" +
                    "</svg>",

                    "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-6 w-6\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\">\n" +
                    "  <path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 5l7 7-7 7\" />\n" +
                    "</svg>"
                ],
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                responsive: {
                    0: {
                        items: 1,
                        stagePadding: 65,
                    },
                    640: {
                        items: 2,
                        stagePadding: 0,
                    },
                    1000: {
                        items: 4,
                    }
                }
            });

    }
});
